import React from 'react';
import { IconProps } from '.';

const SvgCopy = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M16 2.25H3.25V17h1.5V3.75H16v-1.5Z' />
      <path fill={color} fillRule='evenodd' d='M6 22V5h14v17H6ZM7.5 6.5h11v14h-11v-14Z' clipRule='evenodd' />
    </svg>
  );
};

export default SvgCopy;
